import { FC, useState } from "react";
import { classes, stylesheet } from "typestyle";
import { IActivityEntry } from "@hulanbv/platformapp";
import { Flex } from "../../../elements/flex.element";
import { Button } from "../../../elements/button.element";
import { Card } from "../../../elements/card.element";

type Props = {
  value: IActivityEntry;
  onComplete: (obstacle: string) => void;
};

const ThoughtsOnCardsOverviewView: FC<Props> = ({ value, onComplete }) => {
  const [obstacle, setObstacle] = useState<string>("");
  return (
    <Flex
      flex={1}
      justifyContent="center"
      alignItems="stretch"
      direction="column"
      attributes={{ style: { marginBottom: 50 } }}
    >
      <p className={styles.info}>
        When you think about moving toward this value, list all of the reasons
        your mind tells you why you <strong>can't</strong>. Try to get a full
        list of <strong>10-15</strong> reasons.
      </p>
      <Flex
        flex={1}
        direction="column"
        justifyContent="stretch"
        attributes={{ style: { position: "relative" } }}
      >
        <Card
          key={`${value.id}`}
          attributes={{
            className: classes(styles.card),
          }}
        >
          <Flex direction="column" alignItems="stretch" flex={1} padding={20}>
            <h3 style={{ margin: 0 }}>{value.input}</h3>
            <p style={{ margin: 0, overflowY: "auto" }}>{value.value}</p>

            <textarea
              className={styles.input}
              style={{ flex: 1 }}
              placeholder="List 10-15 barriers here."
              onInput={(event) =>
                setObstacle((event.target as HTMLTextAreaElement).value)
              }
            />
          </Flex>
        </Card>
      </Flex>
      <Flex direction="row" justifyContent="flex-end" flex={0}>
        <Button
          hideSpinnerOnSubmit
          centerChildren
          attributes={{
            disabled: obstacle.trim().length === 0,
            onClick: () => {
              onComplete(obstacle);
            },
          }}
        >
          Complete
        </Button>
      </Flex>
    </Flex>
  );
};

export { ThoughtsOnCardsOverviewView };

const styles = stylesheet({
  info: {
    fontSize: ".9em",
    color: "rgb(var(--rgb-color-text-tertiary))",
    textAlign: "center",
    margin: 0,
  },

  card: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    translate: "0 0",
  },

  discarded: {
    translate: "-100% 0 !important",
    rotate: "-20deg",
    transformOrigin: "left bottom",
  },

  input: {
    fontFamily: "inherit",
    position: "relative",
    outline: "none",
    fontSize: "0.93rem",
    color: "rgb(var(--rgb-color-black))",
    backgroundColor: "rgb(var(--rgb-color-gray-lighter))",
    padding: "19px 14px",
    border: "1px solid transparent",
    borderRadius: "var(--border-radius-large)",
    width: "100%",
    resize: "none",
    minHeight: 200,
    $nest: {
      "&:focus": {
        border: "1px solid rgb(var(--rgb-color-primair-basis))",
      },
      "&::placeholder": {
        color: "rgba(var(--rgb-color-black), 0.5)",
        fontSize: "0.93rem",
      },
    },
  },
});
